import { RawAxiosRequestHeaders, ResponseType } from 'axios';
import Cookies from 'js-cookie';
import { COOKIE_NAME_FOR_API_KEY, HEADER_NAME_FOR_API_KEY, HEADER_NAME_FOR_LANGUAGE } from '../constants/api';

export const getFetchHeaders = (language: string) => {
  const apiKey = Cookies.get(COOKIE_NAME_FOR_API_KEY);
  return apiKey != null ? { [HEADER_NAME_FOR_API_KEY]: apiKey, [HEADER_NAME_FOR_LANGUAGE]: language } : undefined;
};

export const postWithKeepAlive = async (path: string, language: string) => {
  // 参考：https://qiita.com/okaits/questions/045034b783e69d2453b0
  // unload イベントでロック解除するときに利用
  await fetch(`${process.env.REACT_APP_API_BASE_PATH ?? ''}${path}`, {
    method: 'POST',
    headers: getFetchHeaders(language),
    keepalive: true,
  });
};

export const getAxiosRequestConfig = (language: string) => {
  const apiKey = Cookies.get(COOKIE_NAME_FOR_API_KEY);
  const config = {
    baseURL: process.env.REACT_APP_API_BASE_PATH ?? '',
    headers:
      apiKey != null
        ? ({ [HEADER_NAME_FOR_API_KEY]: apiKey, [HEADER_NAME_FOR_LANGUAGE]: language } as RawAxiosRequestHeaders)
        : undefined,
  };
  return config;
};

export const getAxiosRequestConfigForBinary = (language: string) => {
  const axiosConfig = getAxiosRequestConfig(language);
  return { ...axiosConfig, responseType: 'blob' as ResponseType };
};

export const getOptionsForBinary = (language: string) => {
  const axiosConfig = getAxiosRequestConfigForBinary(language);
  const options = {
    query: { enabled: false, cacheTime: 0 },
    axios: axiosConfig,
  };
  return options;
};

export const getDefaultOptions = (language: string, refetchInterval: false | number = false) => {
  const axiosConfig = getAxiosRequestConfig(language);
  const options = {
    query: {
      refetchInterval,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchIntervalInBackground: true,
      cacheTime: 0,
    },
    axios: axiosConfig,
  };
  return options;
};
